'use client'

import { Fragment, ReactElement } from 'react'

import BreadcrumbsGoogleSchema from '@/components/site/BreadcrumbsGoogleSchema'
import { Link } from '@/i18n/navigation'

import styles from './styles.module.scss'

interface Props {
    items: { title: string; href?: string }[]
}

export default function Breadcrumbs({ items = [] }: Props): ReactElement {
    return (
        <>
            <BreadcrumbsGoogleSchema links={items} />
            <div className={styles.scroll}>
                <div className={styles.breadcrumbs}>
                    {items.map((item, index) =>
                        item.href ? (
                            <Fragment key={`link-${index}`}>
                                <Link
                                    href={item.href}
                                    className={styles.breadcrumbs__link}
                                >
                                    {item.title}
                                </Link>
                                <div className={styles.breadcrumbs__separator}>
                                    {'→'}
                                </div>
                            </Fragment>
                        ) : (
                            <span
                                key={`link-${index}`}
                                className={styles.breadcrumbs__current}
                            >
                                {item.title}
                            </span>
                        )
                    )}
                </div>
            </div>
        </>
    )
}
